import app from 'app';
import wishlist from './wishlist/index';

app.add({
  wishlist,
});

app.mount();
